const mapData = require('./map-data');
const fetchWordpress = require('../api/wordpress');

async function mapPopularTabs(post) {
  const { props: initialProps } = mapData.pageData(post, page => ({
    props: page.acf
  }));
  const { popular, editors_picks } = initialProps;
  const pendingProps = Object.keys({ popular, editors_picks }).map(async propType => {
    const ids = initialProps[propType];
    const pendingData = ids.map(async id => {
      const pendingSubProps = await fetchWordpress(`posts/${id}`);
      return mapData.pageData(pendingSubProps);
    });
    const data = await Promise.all(pendingData);
    return { type: propType, data };
  });
  const props = await Promise.all(pendingProps);
  return props;
}

async function asideData() {
  const popularTabs = await fetchWordpress('posts/1475');
  const defaultAsideProps = await mapPopularTabs(popularTabs);
  const advertisingAside = await fetchWordpress('posts/1463');
  const advertisingAside2 = await fetchWordpress('posts/2554');
  const asideForm = await fetchWordpress('posts/1484');
  const asideIcons = await fetchWordpress('posts/1788');
  const asideLongAdvertise = await fetchWordpress('posts/1807');
  return {
    defaultAsideProps,
    'aside-post-tabs-long': {
      acf_fc_layout: 'aside-post-tabs-long',
      tabs: defaultAsideProps
    },
    [advertisingAside.slug]: {
      acf_fc_layout: advertisingAside.slug,
      ...advertisingAside.acf
    },
    [advertisingAside2.slug]: {
      acf_fc_layout: advertisingAside.slug,
      ...advertisingAside2.acf
    },
    [asideForm.slug]: {
      acf_fc_layout: asideForm.slug,
      ...asideForm.acf
    },
    [asideIcons.slug]: {
      acf_fc_layout: asideIcons.slug,
      ...asideIcons.acf
    },
    [asideLongAdvertise.slug]: {
      acf_fc_layout: asideLongAdvertise.slug,
      ...asideLongAdvertise.acf
    }
  };
}

module.exports = {
  mapPopularTabs,
  asideData
};
